import { Col, Text } from 'components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const StyledList = styled.ol`
  li {
    margin-bottom: 32px;

    p {
      margin-top: 16px;
    }

    li {
      margin-top: 16px;
      margin-bottom: 0;

      li {
        margin-top: 8px;
      }
    }
  }
`;

const Paragraph = (props) => <Text marg="34px 0 0" {...props} />;

const TermsAndConditions = ({}) => {
  const { t } = useTranslation(),
    { isMobile } = useSelector((state) => state.appState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Col wid="100vw" center marg="0 0 100px">
      <Col noFlex wid={isMobile ? 'calc(100vw - 32px)' : '1140px'} center>
        <Text wid="100%" h1 center marg="0 0 32px">
          Terms and Conditions
        </Text>
        <b>
          <Text bold>
            These Terms apply to your use of the Website (as that term is defined below). BY
            ACCESSING AND USING OUR WEBSITE,:
          </Text>

          <ul>
            <li>YOU AGREE TO THESE TERMS;</li>
            <li>
              YOU ARE AT LEAST 18 YEARS OLD. IF YOU ARE UNDER THE AGE OF 18, YOU MAY ONLY ACCESS AND
              OUR SERVICE WITH THE CONSENT OF A PARENT OR LEGAL GUARDIAN. YOU CONFIRM THAT A PARENT
              OR LEGAL GUARDIAN HAS REVIEWED AND DISCUSSED THESE TERMS WITH YOU; AND
            </li>
            <li>
              WHERE YOUR ACCESS AND USE IS ON BEHALF OF ANOTHER PERSON (E.G. A COMPANY), YOU CONFIRM
              THAT YOU ARE AUTHORISED TO, AND DO IN FACT, AGREE TO THESE TERMS ON THAT PERSON’S
              BEHALF AND THAT, BY AGREEING TO THESE TERMS ON THAT PERSON’S BEHALF, THAT PERSON IS
              BOUND BY THESE TERMS.
            </li>
          </ul>
        </b>
        <Paragraph bold>
          If you do not agree to these Terms, you are not authorized to access and use the Website,
          and you must immediately stop doing so.
        </Paragraph>
        <Paragraph bold>Definitions & Interpretation</Paragraph>
        <Paragraph>In these Terms:</Paragraph>
        <Paragraph>
          "Chargeback" means a bona fide demand by a credit-card provider for Playaz4Playaz to make
          good the loss the credit card provider has incurred because the User has without
          justification disputed a purchase for which the User paid for using the User’s credit
          card;
        </Paragraph>
        <Paragraph>
          "Confidential Information" means any information that is not public knowledge and that is
          obtained from the other party in the course of, or in connection with, the provision and
          use of the Service. Our Confidential Information includes Intellectual Property owned by
          us (or our licensors), including the Playaz4Playaz Software. Your Confidential Information
          includes the Data.
        </Paragraph>
        <Paragraph>
          "Content" means any data, content, information or material (including Personal Data)
          owned, held, used or created by you or on your behalf that is uploaded to, stored using or
          inputted into Playaz4Playaz by any User (whether a Club House Member, Creator, Fan, or
          Sponsor), including any photos, videos, audio (for example music and other sounds),
          livestream material, data, text (such as comments and hashtags), metadata, images,
          interactive features, emojis, GIFs, memes, and any other material whatsoever;
        </Paragraph>
        <Paragraph>
          "Club House Member" means a User who has set up their Playaz4Playaz account as a Club
          House Member account, as approved by us, to post Content on Playaz4Playaz to be viewed by
          other Users;
        </Paragraph>
        <Paragraph>
          "Creator" means a User who creates a profile page and uploads content on the Website to be
          viewed by other Users;
        </Paragraph>
        <Paragraph>
          "Fan" means a User who follows a Club House Member and is able to view the Club House
          Member's Content;
        </Paragraph>
        <Paragraph>
          "Fan Payment" means any and all payments made by a Fan to a Club House Member including,
          but not limited to, payments for access to a Club House Member's Content, payments for
          interaction with the Club House Member through a VIP Connect, or to procure new Content
          from the Club House Member;
        </Paragraph>
        <Paragraph>
          "Fees" means the applicable fees set out on our pricing page on the Website at insert link
          including Fan Payments or subscription payments or as agreed otherwise in writing between
          you and us, as may be updated from time to time in accordance with clause
        </Paragraph>
        <Paragraph>
          "Force Majeure" means an event that is beyond the reasonable control of a party,
          excluding:
        </Paragraph>
        <ul style={{ marginTop: 0 }}>
          <li>
            an event to the extent that it could have been avoided by a party taking reasonable
            steps or reasonable care; or
          </li>
          <li>a lack of funds for any reason;</li>
        </ul>
        <Paragraph>"including" and similar words do not imply any limit;</Paragraph>
        <Paragraph>
          "Intellectual Property Rights" includes copyright and all rights existing anywhere in the
          world conferred under statute, common law or equity relating to inventions (including
          patents), registered and unregistered trademarks and designs, circuit layouts, data and
          databases, confidential information, know-how, and all other rights resulting from
          intellectual activity. "Intellectual Property" has a consistent meaning, and includes any
          enhancement, modification or derivative work of the Intellectual Property.
        </Paragraph>
        <Paragraph>
          "Objectionable" includes being objectionable, defamatory, libelous, obscene,
          discriminatory, inciting violence, harassing, threatening, harassing, harmful, fraudulent
          or unlawful in any way.
        </Paragraph>
        <Paragraph>
          "P4P", "we", "us", "our" means PLAYAZ4PLAYAZ PTE LTD, with company registration number:
          202017746Z and registered address: 68 Circular Road #02-01, Singapore, 049422;
          Playaz4Playaz.com LLC, a wholly owned subsidiary of PLAYAZ4PLAYAZ PTE LTD.
        </Paragraph>
        <Paragraph>a "party" includes that party’s permitted assigns;</Paragraph>
        <Paragraph>
          "Payment Provider" means any third party approved by P4P which enables a User to make
          payments;
        </Paragraph>
        <Paragraph>
          "Playaz4Playaz" means the social network of Users operating on the Website which enables
          Users to provide and view Content and/or pay to view Content uploaded by Club House
          Members and where appropriate, utilize Supporter Interaction;
        </Paragraph>
        <Paragraph>
          "Playaz4Playaz Software" means the software owned by us (and our licensors) that is used
          to provide the Website
        </Paragraph>
        <Paragraph>
          "Refund" means the return of monies to a Fan after a bona fide dispute, often issued prior
          to a chargeback;
        </Paragraph>
        <Paragraph>
          "Sponsor" means a person or organization who aims to generate brand awareness for their
          related product and/or service;
        </Paragraph>
        <Paragraph>
          a "person" includes an individual, a body corporate, an association of persons (whether
          corporate or not), a trust, a government department, or any other entity.
        </Paragraph>
        <Paragraph>
          "Personal Data" means information about an identifiable, living person.
        </Paragraph>
        <Paragraph>
          "personnel" includes officers, employees, contractors and agents, but a reference to your
          personnel does not include us.
        </Paragraph>
        <Paragraph>
          "Sponsor Payment" means any and all payments made by a Sponsor to a Club House Member;
        </Paragraph>
        <Paragraph>
          "Start Date" means the date that you either set up a User Account or first access or use
          the Playaz4Playaz.
        </Paragraph>
        <Paragraph>
          "Supporter" means a User who follows another Creator and views the Creator’s Content;
        </Paragraph>
        <Paragraph>
          "Supporter Interaction" means any functionality offered by a Club House Member or a
          Creator which is hosted by Playaz4Playaz which allows a Fan or Supporter to interact with
          (as opposed to just view) User Content.
        </Paragraph>
        <Paragraph>"Terms" means these terms titled terms and conditions.</Paragraph>
        <Paragraph>
          "Underlying Systems" means the Playaz4Playaz Software, IT solutions, systems and networks
          (including software and hardware) used to provide the Website, including any third-party
          solutions, systems and networks.
        </Paragraph>
        <Paragraph>
          "User" means any user of the Website, whether a Creator, Club House Member, Fan or a
          Supporter;
        </Paragraph>
        <Paragraph>
          "User Account" means the section on the Website which can only be accessed by P4P or the
          User which inter alia details the Payment Provider and Payout Options;
        </Paragraph>
        <Paragraph>
          "VIP Connect" means the live streaming functionality through which Club House Members can
          connect with Fans;
        </Paragraph>
        <Paragraph>"Website" means the website at www.Playaz4Playaz.com.</Paragraph>
        <StyledList>
          <b>
            <li>
              About
              <Text>
                <ol>
                  <li>
                    The Website is a social media website and application service which allows Users
                    to create a profile, upload photos, discover, watch and share videos and other
                    content videos onto their profile for free. Users may access the Website for
                    free, or access Club House Member’s Content on a subscription fee basis.
                    Playaz4Playaz.com provides a forum for people to connect, inform, and inspire
                    others across the globe, and acts as a distribution platform for original
                    content creators and advertisers.
                  </li>
                  <li>
                    These Terms, the Community Guidelines, Privacy Policy and the Copyright and
                    Digital Millennium Copyright Act ("DMCA") govern your use of the Website, and
                    are incorporated by reference.
                  </li>
                  <li>
                    Any information given on the Website including responses to "frequently answered
                    questions" is not legally binding on P4P, is informative only and does not form
                    part of the Terms. Any other links or references provided in these terms are for
                    informational use only and are not part of the Terms.
                  </li>
                  <li>
                    P4P may changes to these Terms at any time by notifying you of the change, or
                    posting a notice on the Website. Unless stated otherwise, all changes are
                    effective immediately from the time P4P posts them. By continuing to use
                    Playaz4Playaz, you agree to the Terms as modified or as they currently appear.
                    You are responsible for ensuring you are aware of any changes, as they are
                    binding on you. These Terms were last updated on February 2, 2021.
                  </li>
                  <li>
                    By using Playaz4Playaz you consent to receiving communications from P4P
                    electronically, including emails and messages posted to your Playaz4Playaz
                    account, as set out in the Privacy. You acknowledge and agree that all
                    communications that P4P sends to you electronically satisfy any legal
                    requirement that such communications be in writing. If you wish at any time to
                    withdraw your consent to receiving communications from P4P, please email
                    Admin@Playaz4Playaz.com, notifying P4P of the withdrawal of your consent.
                  </li>
                </ol>
              </Text>
            </li>

            <li>
              How It Works
              <Text>
                <ol>
                  <li>
                    Playaz4Playaz is a social media platform that lets you create a User profile
                    which in turn allows you to:
                    <ol type="A">
                      <li>
                        upload Content to be viewed by other Users or participate in Supporter
                        Interaction to be used by other Supporters; and/or
                      </li>
                      <li>
                        pay to subscribe to Content uploaded by Club House Members and/or pay to
                        gain access to interactive features initiated by Club House members and
                        hosted by Playaz4Playaz on the Website.
                      </li>
                    </ol>
                  </li>
                </ol>
              </Text>
            </li>

            <li>
              Account Registration
              <Text>
                <ol>
                  <li>
                    To become a User, you must create a User Account. You must provide a valid email
                    address, a username, and a password or a valid Facebook account. It is a
                    condition of your use of the Website that all the information you to us is true,
                    current, and complete.
                  </li>
                  <li>
                    You agree that all Personal Data you submit to the Website, is governed by P4P’s
                    Privacy Policy at https://Playaz4Playaz.com/privacy.
                  </li>
                  <li>
                    If you wish to view a Club House Member’s Content you will need to provide
                    details of a payment card to a Payment Provider. Your payment card information
                    is stored by the Payment Provider.
                  </li>
                  <li>
                    If you elect to input two or more payment card details onto your User Account,
                    and if your Fan Payment from the first card is rejected because the payment card
                    is no longer valid then the other payment card(s) will be used to collect full
                    payment of your Fan Payment.
                  </li>
                  <li>
                    By registering on Playaz4Playaz, you confirm that:
                    <ol type="A">
                      <li>
                        all User Account registration and profile information is truthful and
                        accurate and that any Content you provide is your own and does not infringe
                        the intellectual property rights or any other proprietary rights of a
                        third-party.
                      </li>
                      <li>
                        if you previously had a User Account with Playaz4Playaz, your old User
                        Account was not terminated or suspended by P4P for violation of the Terms of
                        Service;
                      </li>
                      <li>
                        P4P reserves the right, at any time, to verify the information which you
                        provide to P4P as well as your compliance with the Terms. If P4P is unable
                        to verify this then P4P reserves the right to suspend your account.
                      </li>
                      <li>
                        you will not use any third-party payment processors to accept payments for
                        subscriptions, or any other service, via Playaz4Playaz.
                      </li>
                    </ol>
                  </li>
                  <li>
                    You must not permit any other person to use your User Account. You acknowledge
                    and accept that you are responsible all activities that occur on your account.
                    You must keep your login details confidential and secure, and not disclose them
                    to any other person. You must immediately notify P4P at Admin@Playaz4Playaz.com
                    if you believe or become aware of any disclosure or unauthorized use of your
                    account. You also agree to ensure that you log out of your account at the end of
                    each session.
                  </li>
                  <li>
                    P4P reserves the right to disable any user name, password, or other identifier,
                    whether chosen by you or provided by P4P, at any time and at P4P’s sole
                    discretion for any or no reason, including if, in P4P opinion, you have violated
                    any provision of the Terms.
                  </li>
                  <li>
                    You indemnify us against all liability or loss (including loss of profits,
                    savings, revenue or data, and any other claim, damage, loss, liability and cost,
                    including legal costs on a solicitor and own client basis) we suffer or incur as
                    a direct or indirect result of your failure to comply with these Terms,
                    including any failure of a person who accesses and uses our Website by using
                    your User Account.
                  </li>
                  <li>
                    You can deactivate your User Account at any time. If you are a Fan, your User
                    Account deactivation will take place as soon as reasonably possible. Any
                    subscriptions will be deleted and cannot be subsequently renewed.
                  </li>
                </ol>
              </Text>
            </li>

            <li>
              Subscriptions, Purchases and Payments
              <Text>
                <ol>
                  <li>
                    In order to view a Club House Member’s Content, you must first add a payment
                    card to your User Account. You can then click the 'Subscribe' button on the
                    relevant athlete’s profile page, or make ad hoc payments for VIP Connects. Your
                    payment card details will be passed to a Payment Provider which will take the
                    applicable Fees from your payment card and pay it into P4P’s account.
                  </li>
                  <li>
                    Depending on your use of Playaz4Playaz the Payment Provider will take monthly
                    payments or will take payments for ad hoc purchases offered as part of a Club
                    House Member’s Content. However, you may cancel the monthly payments at any time
                    by going to "membership" and clicking on "my subscription" to cancel or by
                    contacting P4P at Amin@Playaz4Playaz.com. If you cancel your monthly payments
                    you will continue to be permitted to view P4P’s Content until the end of the
                    existing billing period, after which no further payments will be taken from your
                    payment card and you will no longer be able to view a Club House Member’s
                    Content.
                  </li>
                  <li>
                    All payments to view a Club House Member’s Content are final and non-refundable.
                    If P4P is alerted that a Fan has sought and received a Refund or Chargeback, P4P
                    will take additional actions. Any purchase of the right to view a Club House
                    Member’s Content which is subsequently subject to a Refund or Chargeback may
                    result in the User’s account being immediately and permanently excluded from
                    Playaz4Playaz.
                  </li>
                  <li>The Fees exclude sales tax, which you must pay on taxable supplies.</li>
                </ol>
              </Text>
            </li>

            <li>
              Facebook
              <Text>
                Playaz4Playaz allows Users to connect a Facebook account and to post any
                Playaz4Playaz posts to Facebook. By using this feature, you must fully comply with
                and respect Facebook's Terms of Service, which can be read in full here:
              </Text>
            </li>

            <li>
              Suspension and Termination
              <Text>
                <ol>
                  <li>
                    Unless terminated under this clause 6, these Terms and your right to access and
                    use the Website starts on the Start Date, and continues until a party gives at
                    least 30 days’ notice that these Terms and your access to and use of the Website
                    will terminate on the expiry of that notice.
                  </li>
                  <li>
                    If the subscription option you have selected includes a minimum initial term,
                    the earliest date for termination under clause 6.1 will be the expiry of that
                    initial term.
                  </li>
                  <li>
                    Either party may, by notice to the other party, immediately terminate these
                    Terms and your right to access and use the Service if the other party:
                    <ol type="A">
                      <li>breaches any material provision of these Terms and the breach is not:</li>
                      <li>
                        remedied within 10 days of the receipt of a notice from the first party
                        requiring it to remedy the breach, or capable of being remedied; or
                      </li>
                      <li>
                        becomes insolvent, liquidated or bankrupt, has an administrator, receiver,
                        liquidator, statutory manager, mortgagee’s or chargee’s agent appointed,
                        becomes subject to any form of insolvency action or external administration,
                        or ceases to continue business for any reason.
                      </li>
                    </ol>
                  </li>
                  <li>
                    Termination of these Terms does not affect either party’s rights and obligations
                    that accrued before that termination.
                  </li>
                  <li>
                    On termination of these Terms, you must pay all Fees for the provision of the
                    Service prior to that termination.
                  </li>
                  <li>
                    No compensation is payable by us to you as a result of termination of these
                    Terms for whatever reason, and you will not be entitled to a refund of any Fees
                    that you have already paid.
                  </li>
                  <li>
                    Without limiting any other right or remedy available to us, we may restrict,
                    suspend or terminate your access to all or part of the Website and/or delete,
                    edit or remove the relevant Content if we consider that you:
                    <ol type="A">
                      <li>you materially or repeatedly breach these Terms or applicable law;</li>
                      <li>
                        share Content (whether reported by another User or not), that we deem to be
                        Objectionable or in breach of our Acceptable Use policy;
                      </li>
                      <li>
                        undermined, or attempted to undermine, the security or integrity of the
                        Website or any Underlying Systems;
                      </li>
                      <li>
                        used, or attempted to use, the Website for improper purposes, or in a
                        manner, other than for normal operational purposes, that materially reduces
                        the operational performance of the Website;
                      </li>
                      <li>
                        transmitted, inputted or stored any Content that breaches or may breach
                        these Terms or any third party right (including Intellectual Property Rights
                        and privacy rights), or that is or may be Objectionable, incorrect or
                        misleading;
                      </li>
                      <li>
                        we are required to do so to comply with a legal requirement or a court
                        order; or
                      </li>
                      <li>
                        we believe your conduct creates (or could create) liability or harm to any
                        User, third party, P4P or our Affiliates.
                      </li>
                    </ol>
                  </li>
                  <li>
                    We may
                    <ol type="A">
                      <li>
                        monitor your use of Playaz4Playaz (including any Content share) to verify
                        compliance with these Terms and/or any applicable law;
                      </li>
                      <li>
                        investigate any suspected or alleged misuse or unlawful use of Playaz4Playaz
                        and cooperate with law enforcement agencies in such investigation;
                      </li>
                      <li>
                        disclose information about your use of Playaz4Playaz in connection with law
                        enforcement investigation of any suspected or alleged illegal activity, or
                        in response to a lawful court order; or
                      </li>
                      <li>
                        change the Payment Providers. If P4P changes Payment Providers P4P will use
                        its reasonable efforts to verify the bona fide and good standing of the new
                        Payment Provider and notify the Fan and applicable details will be uploaded
                        to the Fan’s account.
                      </li>
                    </ol>
                  </li>
                  <li>
                    P4P may terminate your access to all or part of the Website if P4P believes, in
                    its sole discretion, that you are misusing the Service or any functionality so
                    that the provision of the Service to you is no longer commercially viable.
                  </li>
                  <li>
                    We will notify you by email with the reason for termination or suspension by P4P
                    unless we reasonably believe that to do so: (a) would violate the law or the
                    direction of a legal enforcement authority, or would otherwise risk legal
                    liability for P4P, Playaz4Playaz or our Affiliates; (b) would compromise an
                    investigation or the integrity or operation of the Website; or (c) would cause
                    harm to any user, other third party, P4P or our Affiliates. Where P4P is
                    terminating your access for Service changes, where reasonably possible, you will
                    be provided with sufficient time to export your Content from the Website.
                  </li>
                  <li>
                    If your account is terminated or your account’s access to the Website is
                    restricted, you may continue using certain aspects of the Website (such as
                    viewing only) without an account, and these Terms will continue to apply to such
                    use. To appeal contact us by email at Admin@Playaz4Playaz.com.
                  </li>
                </ol>
              </Text>
            </li>
            <li>
              Intellectual Property Rights
              <Text>
                <ol>
                  <li>
                    Other than the Content:
                    <ol type="A">
                      <li>
                        title to, and all Intellectual Property Rights in the Service, the Website
                        and its entire contents, features, and functionality (including but not
                        limited to the Underlying Systems, all information, software, text,
                        displays, images, photos, video, and audio, and the design, selection, and
                        arrangement thereof), remains P4P’s property (and its licensors’ property);
                        and
                      </li>
                      <li>
                        no right, title, or interest in or to the Website or any content on the
                        Website is transferred to you, and all rights not expressly granted are
                        reserved by P4P. Any use of the Website not expressly permitted by these
                        Terms is a breach of these Terms and may violate copyright, trademark, and
                        other laws.
                      </li>
                    </ol>
                  </li>
                  <li>
                    Despite clause 7.1, you may
                    <ol type="A">
                      <li>
                        you may store files that are automatically cached by your Web browser for
                        display enhancement purposes only; and
                      </li>
                      <li>
                        you may print or download one copy of a reasonable number of pages of the
                        Website for your own personal, non-commercial use and not for further
                        reproduction, publication, or distribution.
                      </li>
                    </ol>
                  </li>
                  <li>
                    To the extent not owned by us, you grant us a royalty-free, transferable,
                    irrevocable and perpetual licence to use for our own business purposes any
                    know-how, techniques, ideas, methodologies, and similar Intellectual Property
                    used by us in the provision of the Website.
                  </li>
                  <li>
                    If you provide us with ideas, comments or suggestions relating to the Website or
                    Underlying Systems (together feedback):
                    <ol type="A">
                      <li>
                        all Intellectual Property Rights in that feedback, and anything created as a
                        result of that feedback (including new material, enhancements, modifications
                        or derivative works), are owned solely by us; and
                      </li>
                      <li>we may use or disclose the feedback for any purpose.</li>
                    </ol>
                  </li>
                  <li>
                    The Playaz4Playaz name, logo and all related names, logos, product and service
                    names, designs, and slogans are trademarks of P4P or P4P affiliates or
                    licensors. You must not use such marks without P4P prior written permission. All
                    other names, logos, product and service names, designs, and slogans on the
                    Website are the trademarks of their respective owners.
                  </li>
                  <li>
                    Title to, and all Intellectual Property Rights in, the Content (as between the
                    parties) remains your property. You grant us a worldwide, non-exclusive, fully
                    paid up, transferable, irrevocable licence to use, store, copy, modify, make
                    available and communicate the Content for any purpose in connection with the
                    exercise of our rights and performance of our obligations in accordance with
                    these Terms. We will never sell Content uploaded onto the Website by a Creator
                    to other platforms.
                  </li>
                </ol>
              </Text>
            </li>
            <li>
              Your Obligations
              <Text>
                <ol>
                  <li>
                    You must respect and comply with these Terms, at all times, when using
                    Playaz4Playaz. You must use the Website solely for lawful purposes, and must not
                    make available or resell the Website to any third party.
                  </li>
                  <li>
                    You may not:
                    <ol type="A">
                      <li>
                        use Playaz4Playaz to view or listen to Content other than for your own
                        lawful and personal, non-commercial use in accordance with these Terms (for
                        example, you may not publicly screen videos or stream music);
                      </li>
                      <li>
                        impersonate P4P, one of P4P employees, another User, or any other person or
                        entity or falsely state, suggest or otherwise misrepresent any affiliation,
                        endorsement, sponsorship between you and P4P and/or any other person or
                        entity;
                      </li>
                      <li>
                        falsify account registration information, or make unauthorized use of
                        another's information or content;
                      </li>
                      <li>
                        use Playaz4Playaz in any manner or for any purpose that is illegal or
                        unlawful, including engaging in any activity that violates any right of any
                        person;
                      </li>
                      <li>
                        copy, reproduce, distribute, modify, or create derivative works from, any
                        portion of Playaz4Playaz without P4P express written permission;
                      </li>
                      <li>
                        use Playaz4Playaz for the purpose of exploiting, harming, or attempting to
                        exploit or harm minors in any way by exposing them to inappropriate content,
                        asking for Personal Data, or otherwise;
                      </li>
                      <li>
                        transmit, or procure the sending of, any advertising or promotional
                        material, including any "junk mail", "chain letter", "spam", or any other
                        similar solicitation;
                      </li>
                      <li>
                        engage in any other conduct that restricts or inhibits anyone’s use or
                        enjoyment of the Website, or which, as determined by P4P, may harm P4P or
                        Users of the Website or expose them to liability;
                      </li>
                    </ol>
                  </li>
                  <li>
                    You shall not create, upload, post, display, publish or distribute Content that:
                    <ol type="A">
                      <li>is Objectionable or breaches our Acceptable Use policy;</li>
                      <li>
                        breaches any third party right (including Intellectual Property Rights,
                        privacy, publicity, or other property or personal right e.g. using the name,
                        likeness, image or other identity of another without proper consent), or is
                        incorrect, or misleading
                      </li>
                      <li>
                        promotes or advertises escort services, firearms or other weapons, drugs, or
                        drug paraphernalia, any illegal activity, or advocates, promotes, or assists
                        any unlawful act
                      </li>
                      <li>
                        causes annoyance, inconvenience, or needless anxiety or is likely to upset,
                        embarrass, alarm, or annoy any other person;
                      </li>
                      <li>
                        involves 3rd party commercial activities or sales, such as contests,
                        sweepstakes and other sales promotions, barter, or advertising;
                      </li>
                      <li>
                        gives the impression that it emanates from or is endorsed by P4P or any
                        other person or entity, if this is not the case.
                      </li>
                    </ol>
                  </li>
                  <li>
                    When using the Website, you shall not
                    <ol>
                      <li>
                        impersonate another person or misrepresent authorisation to act on behalf of
                        others or us;
                      </li>
                      <li>
                        remove, erase, modify or tamper with any copyright, trademark or other
                        proprietary rights notice that is contained in any Content that you do not
                        own.
                      </li>
                      <li>
                        attempt to undermine the security or integrity of the Underlying Systems,
                        use the Website in any manner that could disable, overburden, damage, or
                        impair the functionality of the Underlying Systems, or Website or interfere
                        with any other party’s use of the Website, including their ability to engage
                        in real time activities through the Website.
                      </li>
                      <li>
                        decompile, disassemble, reverse engineer, or otherwise attempt to discover
                        or derive the source code of Playaz4Playaz.
                      </li>
                      <li>
                        interfere in any way with the operation of Playaz4Playaz or any server,
                        network or system associated with Playaz4Playaz, including, without
                        limitation: hacking, mail-bombing, flooding, overloading, or making "denial
                        of service" attacks; probing, scanning or testing the vulnerability of the
                        site or any server, network or system associated with the site; breaching or
                        circumventing firewall, encryption, security or authentication routines;
                        accessing information not intended for you, or accessing another user's
                        account that you are not expressly authorized to access.
                      </li>
                      <li>
                        use Playaz4Playaz for any unauthorized purpose, including, without
                        limitation, for purposes of building a competitive product or service,
                        performance or functionality, or for any other competitive purposes;
                      </li>
                      <li>
                        use any automated program, tool or process (including without limitation,
                        web crawlers, robots, bots’ spiders, and automated scripts) to access
                        Playaz4Playaz or any server, network or system associated with
                        Playaz4Playaz, or to extract, collect, harvest or gather content or
                        information from Playaz4Playaz.
                      </li>
                      <li>
                        make any other use of Playaz4Playaz that violates these Terms or any
                        applicable law.
                      </li>
                    </ol>
                  </li>
                  <li>
                    If P4P becomes aware that a User is underage and is not using P4P with a parent
                    or legal guardian’s supervision and consent, P4P will promptly deactivate that
                    User's account and delete all information and content of that User from
                    Playaz4Playaz. If you are a parent or legal guardian and become aware that your
                    minor-child has registered on Playaz4Playaz, please immediately notify P4P at
                    support@Playaz4Playaz.com.
                  </li>
                </ol>
              </Text>
            </li>
            <li>
              Content
              <Text>
                <ol>
                  <li>
                    By creating and publishing Content on Playaz4Playaz, you authorize your Fans
                    and/or Supporters to access and view (without downloading or copying) your
                    Content on Playaz4Playaz for their own lawful and personal use. You also
                    represent and warrant that:
                  </li>

                  <ol type="A">
                    <li>
                      you are responsible for your Content, including its legality, reliability,
                      accuracy, and appropriateness. Playaz4Playaz is under no obligation to host or
                      serve Content, or review or vet Content before it is made available. If you
                      see any Content you believe does not comply with this Agreement, including by
                      violating the or the law, you can report it to us at support@Playaz4Playaz.com
                    </li>
                    <li>you own or have sufficient rights to share your Content;</li>
                    <li>
                      you are responsible for procuring all rights, licenses, consents and releases
                      that are required for you to use the Website, including to use, store and
                      input your Content into, and process and distribute Content through, the
                      Website;
                    </li>
                    <li>
                      you will not post any content depicting any person under 18-years old, unless
                      you are the parent or legal guardian or have obtain the written consent of a
                      parent or legal guardian (of which you must retain a copy);
                    </li>
                    <li>
                      your Content is non-confidential and will be made available to your Fans
                      and/or Supporters on Playaz4Playaz.com.
                    </li>
                  </ol>
                  <li>
                    You acknowledge that:
                    <ol type="A">
                      <li>
                        we may require access to the Content to exercise our rights and perform our
                        obligations under these Terms; and
                      </li>
                      <li>
                        to the extent that this is necessary but subject to clause 9, we may
                        authorize a member or members of our personnel to access the Content for
                        this purpose.
                      </li>
                    </ol>
                  </li>
                  <li>
                    You must arrange all consents and approvals that are necessary for us to access
                    the Content as described in clause 9.
                  </li>
                  <li>
                    You acknowledge and agree that:
                    <ol type="A">
                      <li>we may:</li>
                      <li>
                        use Content and information about your use of the Website to generate
                        anonymised and aggregated statistical and analytical data (Analytical Data);
                        and
                      </li>
                      <li>
                        use Analytical Data for our internal research and product development
                        purposes and to conduct statistical analysis and identify trends and
                        insights; and
                      </li>
                      <li>supply Analytical Data to third parties;</li>
                      <li>
                        our rights under clause 9.4 above will survive termination or expiry of
                        these Terms; and
                      </li>
                      <li>
                        title to, and all Intellectual Property Rights in, Analytical Data is and
                        remains our property.
                      </li>
                    </ol>
                  </li>
                  <li>
                    You acknowledge and agree that to the extent Content contains Personal Data, in
                    collecting, holding and processing that information through the Website, we are
                    acting as your agent for the purposes of the Personal Data Protection Act 2012
                    and any other applicable privacy law. You must obtain all necessary consents
                    from the relevant individual to enable us to collect, use, hold and process that
                    information in accordance with these Terms.
                  </li>
                  <li>
                    While we will take standard industry measures to back up all Content stored
                    using the Website, you agree to keep a separate back-up copy of all Content
                    uploaded by you onto the Website.
                  </li>
                  <li>
                    You agree that we may store Content (including any personal information) in
                    secure servers in the United States and may access that Content (including any
                    personal information) in the United States from time to time.
                  </li>
                  <li>
                    You shall indemnify P4P (including our licensees, successors, and assigns)
                    against all liabilities, costs, claims, proceedings expenses, damages and losses
                    (including any direct, indirect or consequential losses, loss of profit, loss of
                    reputation and all interest, penalties and legal costs (calculated on a full
                    indemnity basis) and all other loss of any kind suffered or incurred arising out
                    of or in connection with your Content (including, to avoid doubt, any actual or
                    alleged claim by a third party that the Content infringes the rights of that
                    third party (including Intellectual Property Rights and privacy rights) or that
                    the Data is Objectionable, incorrect or misleading).
                  </li>
                  <li>
                    P4P is not responsible or liable to any third party for the content or accuracy
                    of any Content posted by you or any other user of the Website.
                  </li>
                  <li>
                    Upon signing up to Playaz4Playaz.com, you also agree to act as custodian of
                    records for your Content
                  </li>
                  <li>
                    If you have a complaint about Content appearing on Playaz4Playaz, please send
                    your complaint to Admin@Playaz4Playaz.com including your name, address, contact
                    details, a description of your complaint and the URL for the Content to which
                    your complaint arises.
                  </li>
                  <li>
                    We will investigate your complain within a timescale which is appropriate to the
                    nature of the your complaint and in good faith take such actions as we consider
                    appropriate to deal with the issue to which your complaint has raised.
                  </li>
                  <li>
                    Any questions regarding Content can be addressed by emailing
                    Admin@Playaz4Playaz.com
                  </li>
                </ol>
              </Text>
            </li>
            <li>
              DMCA
              <Text>
                <ol>
                  <li>
                    Playaz4Playaz respects the intellectual property rights of third parties and
                    voluntarily complies with the Digital Millennium Copyright Act (DMCA). Our full
                    DMCA Notice and Takedown Policy can be found here: Playaz4Playaz has implemented
                    a policy to terminate repeat copyright infringers. A copy of our repeat
                    infringer policy (RIP) is available upon request to our users.
                  </li>
                  <li>
                    Please note that, under the DMCA, any person who knowingly makes material
                    misrepresentations in a notification of claimed infringement or in a
                    counter-notification may be liable for damages.
                  </li>
                </ol>
              </Text>
            </li>
            <li>
              Linking to the Website and Social Media Features
              <Text>
                <ol>
                  <li>
                    You may link to P4P homepage, provided you do so in a way that is fair and legal
                    and does not damage P4P reputation or take advantage of it. You must not
                    establish a link in such a way as to suggest any form of association, approval,
                    or endorsement on P4P part. We may remove links at our discretion.
                  </li>
                  <li>
                    The Website may provide certain social media features that enable you to:
                    <ol type="A">
                      <li>
                        link from your own or certain third-party websites to certain content on the
                        Website;
                      </li>
                      <li>
                        send emails or other communications with certain content, or links to
                        certain content, on the Website;
                      </li>
                      <li>
                        cause limited portions of content on this Website to be displayed or appear
                        to be displayed on your own or certain third-party websites.
                      </li>
                    </ol>
                  </li>
                  <li>
                    You may use these features solely as they are provided by P4P, solely with
                    respect to the Content they are displayed with. However, you must not:
                    <ol type="A">
                      <li>establish a link from any website that is not owned by you;</li>
                      <li>
                        cause the Website or portions of it to be displayed on, or appear to be
                        displayed by, any other site, for example, framing, deep linking, or in-line
                        linking;
                      </li>
                      <li>link to any part of the Website other than the homepage; or</li>
                      <li>
                        otherwise take any action with respect to the materials on this Website that
                        is inconsistent with any other provision of these Terms.
                      </li>
                    </ol>
                  </li>
                  <li>
                    You agree to cooperate with P4P in causing any unauthorized framing or linking
                    immediately to stop. P4P reserves the right to withdraw linking permission
                    without notice.
                  </li>
                  <li>
                    P4P may disable all or any social media features and any links at any time
                    without notice.
                  </li>
                </ol>
              </Text>
            </li>
            <li>
              Links from the Website
              <Text>
                You acknowledge that the Website may link to third party sites and feeds. This
                includes links contained in advertisements, including, without limitation, banner
                advertisements and sponsored links. Any link from the Website does not imply that
                P4P endorses, approves or recommends, or has any responsibility for those sites or
                feeds. To the maximum extent permitted by law, we exclude all responsibility or
                liability for those websites or fees, or for any loss or damage that may arise from
                your use of them.
              </Text>
            </li>
            <li>
              Disclaimer of Warranties; Limitations of Liability
              <Text>
                <ol>
                  <li>
                    By using Playaz4Playaz, you acknowledge and agree as follows:
                    <ol type="A">
                      <li>
                        Playaz4Playaz and all of its services and features are provided without
                        warranties of any kind, express or implied. To the fullest extent permitted
                        by law, P4P disclaim any and all warranties, express or implied, with
                        respect to Playaz4Playaz (including the Website) and all of its services and
                        features, including, and without limitation, implied warranties of
                        merchantability and fitness for a particular purpose. P4P does not warrant
                        or guarantee the accuracy, usefulness, completeness or reliability of
                        Playaz4Playaz, or the results of your use of Playaz4Playaz. P4P disclaim all
                        liability and responsibility arising from any reliance placed on such
                        materials by you or any other visitor to the Website, or by anyone who may
                        be informed of any of its contents. P4P also does not warrant or guarantee
                        that Playaz4Playaz and all of its services and features will be available at
                        any particular time or location; that Playaz4Playaz and all of its services
                        and features will be secure, uninterrupted, and error-free; that any defect
                        or error will be corrected; or that Playaz4Playaz and all of its services
                        and features will be free of viruses and other harmful components. You are
                        responsible for implementing sufficient procedures and checkpoints to
                        satisfy your particular requirements for antivirus protection and accuracy
                        of data input and output, and for maintaining a means external to the
                        Website for any reconstruction of any lost data. To the fullest extent
                        provided by law, P4P will not be liable for any loss or damage caused by a
                        distributed denial-of-service attack, viruses, or other technologically
                        harmful material that may infect your computer equipment, computer programs,
                        data, or other proprietary material due to your use of the Website or any
                        services or items obtained through the Website or to your downloading of any
                        material posted on it, or on any website linked to it. Your use of
                        Playaz4Playaz and its services and features will be solely and entirely at
                        your own risk. The foregoing does not affect any warranties that cannot be
                        excluded or limited under applicable law;
                      </li>
                      <li>
                        P4P does not warrant or guarantee that use of the Website will be
                        uninterrupted or error free twenty-four hours a day, seven days a week,
                        since P4P may need to carry out maintenance of the Website from time to
                        time. However, P4P will use its reasonable endeavors to carry out any such
                        maintenance of the Website outside of business hours and P4P will endeavor
                        to give reasonable notice, however this may not always be possible;
                      </li>
                      <li>
                        in no event shall P4P be liable (strictly or otherwise) in contract, tort,
                        negligence, strict liability or under any other legal or equitable
                        principle, for any indirect, incidental, exemplary, special, punitive or
                        consequential damages (including, and without limitation, loss of use,
                        profits, data or information, or loss of business goodwill or opportunity)
                        arising out of or related to your use of (or your inability to use)
                        Playaz4Playaz or any of its services or features, nor shall P4P be held
                        liable in the event your Content is illegally distributed by another User,
                        however where such distribution does occur please contact P4P at
                        Admin@Playaz4Playaz.com and P4P will seek to prevent continuance of such
                        distribution where P4P is reasonably able to do so; and
                      </li>
                      <li>
                        in no event shall P4P total and aggregate liability to you and/or others for
                        any and all claims arising out of or related to your use of (or your
                        inability to use) Playaz4Playaz or any of its services or features, exceed
                        one hundred U.S. dollars ($100.00 USD). This does not affect any liability
                        that cannot be excluded or limited under applicable law.
                      </li>
                    </ol>
                  </li>
                  <li>
                    Because some jurisdictions do not allow the exclusion or limitation of liability
                    for consequential or incidental damages or total liability, the above limitation
                    may not apply to you. In such case, our total and aggregate liability to you
                    arising out of or related to your use of (or your inability to use)
                    Playaz4Playaz or any of its services or features shall be limited to the maximum
                    extent permitted by law or, if no amount is specified, one hundred U.S. dollars
                    ($100.00 USD).
                  </li>
                  <li>
                    Each party warrants that it has full power and authority to enter into, and
                    perform its obligations under, these Terms.
                  </li>
                  <li>
                    Where legislation or rule of law implies into these Terms a condition or
                    warranty that cannot be excluded or modified by contract, the condition or
                    warranty is deemed to be included in these Terms. However, our liability for any
                    breach of that condition or warranty is limited, at our option, to supply the
                    relevant services again, or paying the costs of having the relevant services
                    supplied again.
                  </li>
                  <li>
                    Through the use of web services and APIs, the Website interoperates with a range
                    of third party service features. We do not make any warranty or representation
                    on the availability of those features. Without limiting the previous sentence,
                    if a third-party feature provider ceases to provide that feature or ceases to
                    make that feature available on reasonable terms, we may cease to make available
                    that feature to you. To avoid doubt, if we exercise our right to cease the
                    availability of a third party feature, you are not entitled to any refund,
                    discount or other compensation
                  </li>
                </ol>
              </Text>
            </li>
            <li>
              User indemnification
              <Text>
                <ol>
                  By using Playaz4Playaz, you agree to indemnify and hold harmless P4P and our
                  employees, agents, representatives, successors and assigns from and against any
                  and all claims, demands, causes of action, actions, suits, proceedings, judgments,
                  orders, damages, liabilities, losses, costs and expenses (including, without
                  limitation, reasonable attorneys{"'"} fees and legal costs) arising out of or
                  related to any of the following:
                  <ol type="A">
                    <li>your use of Playaz4Playaz or any of its services or features;</li>
                    <li>
                      any Content created, published, or otherwise made available on Playaz4Playaz
                      by you;
                    </li>
                    <li>
                      any transaction or interaction between you and any other User of
                      Playaz4Playaz; and/or
                    </li>
                    <li>your violation of the Terms or any applicable law.</li>
                  </ol>
                </ol>
              </Text>
            </li>
            <li>
              Confidentiality
              <Text>
                <ol>
                  <li>
                    Each party must, unless it has the prior written consent of the other party:
                    <ol type="A">
                      <li>
                        keep confidential at all times the Confidential Information of the other
                        party;
                      </li>
                      <li>
                        effect and maintain adequate security measures to safeguard the other
                        party’s Confidential Information from unauthorised access or use; and
                      </li>
                      <li>
                        disclose the other party’s Confidential Information to its personnel or
                        professional advisors on a need to know basis only and, in that case, ensure
                        that any personnel or professional advisor to whom it discloses the other
                        party’s Confidential Information is aware of, and complies with, clauses
                        15.1.A and 15.1.B.
                      </li>
                    </ol>
                  </li>

                  <li>
                    The obligation of confidentiality in clause 15.1 does not apply to any
                    disclosure or use of Confidential Information:
                    <ol type="A">
                      <li>
                        for the purpose of performing a party’s obligations, or exercising a party’s
                        rights, under these Terms;
                      </li>
                      <li>required by law (including under the rules of any stock exchange);</li>
                      <li>
                        which is publicly available through no fault of the recipient of the
                        Confidential Information or its personnel;
                      </li>
                      <li>
                        which was rightfully received by a party from a third party without
                        restriction and without breach of any obligation of confidentiality; or
                      </li>
                      <li>
                        by us if required as part of a bona fide sale of our business (assets or
                        shares, whether in whole or in part) to a third party, provided that we
                        enter into a confidentiality agreement with the third party on terms no less
                        restrictive than this clause Error! Reference source not found.
                      </li>
                    </ol>
                  </li>
                </ol>
              </Text>
            </li>
            <li>
              Governing Law and Dispute Resolution
              <Text>
                <ol>
                  <li>
                    You and P4P agree that these Terms shall be governed by and construed in
                    accordance with the laws of Delaware (without regard to the conflict of laws
                    provisions thereof) and that any dispute between you and P4P concerning
                    Playaz4Playaz or arising out of or related to these Terms shall be resolved
                    exclusively in the courts of Delaware. All claims arising out of or relating to
                    these terms or the Service will be governed by Delaware law, and will be
                    litigated exclusively in the federal or state courts of, New Castle County
                    Delaware, USA. You and P4P consent to personal jurisdiction in those courts.
                  </li>
                  <li>
                    Except where prohibited by applicable law, any claim or cause of action by you
                    concerning Playaz4Playaz or arising out of or related to these Terms must be
                    filed within one year after such claim or cause of action arose, or be forever
                    barred.
                  </li>
                </ol>
              </Text>
            </li>
            <li>
              Waiver and Severability
              <Text>
                <ol>
                  <li>
                    No waiver of any term or condition set out in these Terms shall be deemed a
                    further or continuing waiver of such term or condition or a waiver of any other
                    term or condition, and any failure to assert a right or provision under these
                    Terms shall not constitute a waiver of such right or provision.
                  </li>
                  <li>
                    If any provision of these Terms is held by a court or other tribunal of
                    competent jurisdiction to be invalid, illegal or unenforceable for any reason,
                    such provision shall be eliminated or limited to the minimum extent such that
                    the remaining provisions of the Terms will continue in full force and effect.
                  </li>
                </ol>
              </Text>
            </li>
            <li>
              General
              <Text>
                <ol>
                  <li>
                    The Terms constitute the sole and entire agreement between you and P4P regarding
                    the Website and supersede all prior and contemporaneous understandings,
                    agreements, representations, and warranties, both written and oral, regarding
                    the Website.
                  </li>
                  <li>
                    If we need to contact you, we may do so by email or by posting a notice on the
                    Website. You agree that this satisfies all legal requirements in relation to
                    written communications. You may give notice to us under or in connection with
                    these Terms by emailing Admin@Playaz4Playaz.com.
                  </li>
                  <li>
                    Neither party is liable to the other for any failure to perform its obligations
                    under these Terms to the extent caused by Force Majeure.
                  </li>
                  <li>
                    No person other than you and P4P has any right to a benefit under, or to
                    enforce, these Terms.
                  </li>
                  <li>
                    Subject to clause 9.5, we are your independent contractor, and no other
                    relationship (e.g. joint venture, agency, trust or partnership) exists under
                    these Terms.
                  </li>
                  <li>
                    These Terms set out everything agreed by the parties relating to the Service,
                    and supersede and cancel anything discussed, exchanged or agreed prior to the
                    Start Date. The parties have not relied on any representation, warranty or
                    agreement relating to the Service that is not expressly set out in these Terms,
                    and no such representation, warranty or agreement has any effect from the Start
                    Date.
                  </li>
                  <li>
                    You may not assign, novate, subcontract or transfer any right or obligation
                    under these Terms without our prior written consent, that consent not to be
                    unreasonably withheld. You remain liable for your obligations under these Terms
                    despite any approved assignment, subcontracting or transfer.
                  </li>
                </ol>
              </Text>
            </li>
            <li>
              Contact
              <Text>
                If you have any questions, comments, complaints or concerns about Playaz4Playaz,
                please contact our support team at Admin@Playaz4Playaz.com
              </Text>
            </li>
          </b>
        </StyledList>
        Last updated: June 2021.
      </Col>
    </Col>
  );
};

export default TermsAndConditions;
